import * as actionTypes from '../../../../models/actionTypes';

export const setIsInitializedOcv = () => {
  return {
    type: actionTypes.SET_ISINITIALIZED_OCV,
  };
};
